import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { P2PScreen } from './P2PScreen';
import { MarketNewsScreen } from './MarketNewsScreen';
import { PriceSetupScreen } from './PriceSetupScreen';
import { RateInquiryScreen } from './RateInquiryScreen';
import { VesselsScreen } from './VesselsScreen';
import { VESSELS, VESSEL_CALLS, VESSEL_EVENTS, VESSEL_FILES, VOYAGE_BOOKINGS } from './vesselFixtures';
import { RatesScreen } from './RatesScreen';
import { COUNTRIES, CUSTOMER_SURCHARGES, HUBS, LOCAL_CHARGES, LOCAL_CHARGE_BUYS, MARGINS, MARGIN_APPROVALS, ROE, TARIFF } from './setupFixtures';
import { FEED_SOURCES, INDICES, NEWS, NOTICES } from './newsFixtures';
import { AGENT_SCORES, INQUIRIES, INQUIRY_AGENTS, INQUIRY_QUOTES, INTERNAL_INQUIRIES } from './inquiryFixtures';
import { ServicesMapScreen } from './ServicesMapScreen';
import { SERVICES } from './servicesFixtures';
import { COST_BUYS, COST_RATES } from './costFixtures';
import { BUY_RATES, RATES, SAILINGS } from './fixtures';
import './types';

const pricing: EzyModule = {
  nav: { key: 'pricing', label: 'Giá & lịch tàu', items: [
      { key: 'p2p', label: 'Giá và Lịch', to: '/ezy' },
      { key: 'rates', label: 'Freight Cost', to: '/ezy/rates' },
      { key: 'services', label: 'Services Map', to: '/ezy/services' },
      { key: 'inquiry', label: 'Hỏi giá đối tác', to: '/ezy/inquiry' },
      { key: 'setup', label: 'Thiết lập giá', to: '/ezy/setup' },
      { key: 'news', label: 'Tin thị trường', to: '/ezy/news' },
    ],
  },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/', component: P2PScreen }),
    createRoute({ getParentRoute: () => parent, path: '/rates', component: RatesScreen }),
    createRoute({ getParentRoute: () => parent, path: '/services', component: ServicesMapScreen }),
    createRoute({ getParentRoute: () => parent, path: '/inquiry', component: RateInquiryScreen }),
    createRoute({ getParentRoute: () => parent, path: '/setup', component: PriceSetupScreen }),
    createRoute({ getParentRoute: () => parent, path: '/news', component: MarketNewsScreen }),
    createRoute({ getParentRoute: () => parent, path: '/vessels', component: VesselsScreen }),
  ],
  fixtures: (register) => {
    register('p2pRate', RATES);
    register('p2pBuyRate', BUY_RATES);
    register('costRate', COST_RATES);
    register('costBuy', COST_BUYS);
    register('service', SERVICES);
    register('inquiry', INQUIRIES);
    register('inquiryAgent', INQUIRY_AGENTS);
    register('inquiryQuote', INQUIRY_QUOTES);
    register('internalInquiry', INTERNAL_INQUIRIES);
    register('agentScore', AGENT_SCORES);
    register('localCharge', LOCAL_CHARGES);
    register('localChargeBuy', LOCAL_CHARGE_BUYS);
    register('transshipHub', HUBS);
    register('tariffService', TARIFF);
    register('customerSurcharge', CUSTOMER_SURCHARGES);
    register('roe', ROE);
    register('country', COUNTRIES);
    register('marginRule', MARGINS);
    register('marginApproval', MARGIN_APPROVALS);
    register('vessel', VESSELS);
    register('vesselCall', VESSEL_CALLS);
    register('voyageBooking', VOYAGE_BOOKINGS);
    register('vesselEvent', VESSEL_EVENTS);
    register('vesselFile', VESSEL_FILES);
    register('newsItem', NEWS);
    register('carrierNotice', NOTICES);
    register('marketIndex', INDICES);
    register('feedSource', FEED_SOURCES);
    register('sailing', SAILINGS);
  },
};
export default pricing;
